import * as yup from "yup";

const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
export const letterSizeMinRegex = /^.{8,}$/;
export const UppercaseRegex = /[A-Z]/;
export const LowercaseRegex = /[a-z]/;
export const numberRegex = /\d/;

export const EmailSchema = yup
  .string()
  .trim()
  .required("Required")
  .matches(emailRegex, "Email is invalid");

export const LoginFormSchema = yup.object({
  email: EmailSchema,
  password: yup.string().trim().required("Required"),
});

export type LoginFormSchemaType = yup.InferType<typeof LoginFormSchema>;

export const ForgotPasswordSchema = yup.object({
  email: EmailSchema,
});

export type ForgotPasswordSchemaType = yup.InferType<
  typeof ForgotPasswordSchema
>;

export const CreatePasswordSchema = yup.object({
  password: yup
    .string()
    .trim()
    .required("Required")
    .min(8, "Password needs to be at least 8 characters long"),
});

export type CreatePasswordSchemaType = yup.InferType<
  typeof CreatePasswordSchema
>;
